import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import FontAwesome from 'react-fontawesome'
import moment from 'moment';
import numeral from 'numeral';
import Pagination from 'react-js-pagination';
import Box from '../Layout/Box';
import ButtonStrip from '../Layout/ButtonStrip';
import BoxButton from '../Layout/BoxButton';
import history from '../../utils/history';
import ModalSelectorFromList from '../Shared/ModalSelectorFromList';
import ModalFilter from './ModalFilter';
import SelectorInput from '../Shared/SelectorInput';
import store from '../../utils/store';
import { changeNumberRegisterToShow, downloadFile, getCumplimientoResponsableCompras, setOrderBy, showHideModalFilter, updateInputs } from '../../actions/reportes';
import { showModalSelector, selectFromSelector } from '../../actions/common';
import { extractKeyValue } from '../../utils/helpers';

export function findValues(c, x) {
    const enums = store.getState().common.get('enums').toJS()
    let value = x.getIn(c.value.split('.'))
    if (!value) {
        return value;
    }
    if (c.value === 'tipo_solicitud') {
        value = enums.solicitudes.tipos[value].caption
    } else if (c.value === 'evento') {
        value = enums.etapas[value];
    }
    return value
}

class CumplimientoResponsableCompras extends React.Component {

    handleOpenSelectorProveedor = (list) => {

        let columns = [
            { id: 1, caption: 'Id', value: 'username', width: '30%' },
            { id: 2, caption: 'Nombres', value: 'nombres', width: '35%' },
            { id: 3, caption: 'Apellidos', value: 'apellidos', width: '35%' }
        ];

        const payload = {};

        const fn = (a) => {
            payload.path = list
            payload.value = a;
            this.props.selectFromSelector('MODIFICAR_INPUTS_REPORTES', payload);
        };

        this.props.showModalSelector('Listado de responsables de compras', columns, `/solicitudes/get_responsable_compras`, fn);
    }

    newPageOfResults(pg) {
        this.props.search(pg);
    }

    downloadFile(type_report) {
        const url = '/reportes/download_cumplimiento_responsable_compras';
        let responsable_nombre = null;
        if (this.props.reportes.getIn(['purchasing_manager', 'username'])) {
            responsable_nombre = this.props.reportes.getIn(['purchasing_manager', 'nombres'])+" "+this.props.reportes.getIn(['purchasing_manager', 'apellidos']);
        }
        let filters = this.props.reportes.getIn(['compliance_purchasing_manager', 'modalFilter', 'filters']).filter(column => column.get('apply')).toJS();
        const indexEtapa = filters.findIndex((f)=>f.column === 'evento');
        if (indexEtapa >= 0) {
            const evento = filters[indexEtapa];
            const etapas = store.getState().common.getIn(['enums', 'etapas']).filter(e => e == evento.value)
            if (etapas.count()) {
                const value = etapas.keySeq().toArray().join('|')
                const operator = evento.operator === "!==" ? "NOT REGEXP" : "REGEXP"
                filters = [
                    ...filters.slice(0, indexEtapa),
                    {"column": "evento","operator": operator,"value":value, "comparison":"string" },
                    ...filters.slice(indexEtapa+1)
                ];
            }
        }
        const params = {
            responsable_id: this.props.reportes.getIn(['purchasing_manager', 'username']),
            responsable_nombre,
            filters,
            type_report
        };
        return this.props.downloadFile(url, params, type_report);
    }

    render() {
        const { reportes, enums, orderBy, showRecords, totalRecords, page } = this.props;

        const tableCols = [
            { id: 1, caption: 'Responsable Compras', value: 'responsable', type: 'string', format: '', width: '20%' },
            { id: 2, caption: 'Tipo Solicitud', value: 'tipo_solicitud', type: 'string', width: '17%', enums: extractKeyValue(enums.solicitudes.tipos, 'caption') },
            { id: 3, caption: 'No. Solicitud', value: 'numero_solicitud', type: 'number', width: '10%' },
            { id: 4, caption: 'Orden/Contrato', value: 'numero_documento', type: 'string', width: '11%' },
            { id: 5, caption: 'OTROSÍ', value: 'otrosi', type: 'string', width: '10%' },
            { id: 6, caption: 'Etapa', value: 'evento', type: 'string', width: '20%', enums: extractKeyValue(enums.etapasFilter) },
            { id: 7, caption: 'Horas', value: 'horas', type: 'number', format: '0,0[.]00', width: '10%' },
        ];

        const filters_cols = [
            { id: 1, caption: 'Responsable Compras', value: 'responsable', type: 'string', format: '', width: '20%' },
            { id: 2, caption: 'Tipo Solicitud', value: 'tipo_solicitud', type: 'string', width: '17%', enums: extractKeyValue(enums.solicitudes.tipos, 'caption') },
            { id: 3, caption: 'No. Solicitud', value: 'numero_solicitud', type: 'number', width: '10%' },
            { id: 4, caption: 'Orden/Contrato', value: 'numero_documento', type: 'string', width: '11%' },
            { id: 5, caption: 'OTROSÍ', value: 'otrosi', type: 'string', width: '10%' },
            { id: 6, caption: 'Etapa', value: 'evento', type: 'string', width: '20%', enums: extractKeyValue(enums.etapasFilter) },
        ];

        const boxActions = [
            <BoxButton key="ba[0][0]" name="search" title="Buscar" onClick={e => this.newPageOfResults(1)} />,
            <BoxButton key="ba[0][1]" name="filter" onClick={ e => this.props.showHideModalFilter(true, filters_cols) } title="Filtro"/>,
            <BoxButton key="ba[0][2]" name="file-excel-o" onClick={ e => this.downloadFile('xlsx') } title="Descargar excel"/>,
            <BoxButton key="ba[0][3]" name="file-pdf-o" onClick={ e => this.downloadFile('pdf') } title="Descargar PDF"/>,
        ];
        const pagination = <Pagination
            activePage={page}
            itemsCountPerPage={showRecords}
            totalItemsCount={totalRecords}
            pageRangeDisplayed={10}
            onChange={(pg) => this.newPageOfResults(pg)}
            firstPageText={<FontAwesome name="angle-double-left" />}
            prevPageText={<FontAwesome name="angle-left" />}
            nextPageText={<FontAwesome name="angle-right" />}
            lastPageText={<FontAwesome name="angle-double-right" />}
        />

        const formRequest = <div className="row" style={{padding:'0px'}}>

            <div className="col-md-4 col-sm-4 col-xs-12">
                <div className="form-group">
                    <label className="control-label">Responsable Compras</label>
                    <SelectorInput
                        value={reportes.get('purchasing_manager') ? reportes.getIn(['purchasing_manager', 'nombres'])+" "+reportes.getIn(['purchasing_manager', 'apellidos']) : ''}
                        onClick={() => this.handleOpenSelectorProveedor('purchasing_manager')}
                        onReset={() => this.props.updateInputs('purchasing_manager', null)}
                    />
                </div>
            </div>
            
        </div>



        return (
            <div className="row" style={{ height: '100%' }}>
                <div className="col-md-12 col-sm-12 col-xs-12" style={{ height: '100%' }}>

                    <Box title="Reporte cumplimiento del responsable de compras" stretch>

                        <ButtonStrip actions={boxActions} totalRecords={totalRecords}
                            showRecords={showRecords} pagination={pagination}
                            changeRecordsToShow={(records) => this.props.changeNumberRecordsToShow(records)}
                            formRequest = { formRequest } 
                        />

                        <div className="box-content" style={{ flex: 1, height: 0, overflow: 'auto' }}>
                            <div style={{ display: 'flex', height: '100%', justifyContent: 'space-between', flexDirection: 'column' }}>

                                <table className="table table-condensed table-bordered table-striped table-sorted nowrap" id="table-cumplimiento-responsable">
                                    <thead>
                                        <tr>
                                            {
                                                tableCols.map(x => {
                                                    const style = { width: `${x.width}` }
                                                    return (
                                                        <th key={ `th1[${x.id}]` } style={ style } onClick={ e => this.props.setOrderBy(x) }
                                                            className={ (orderBy.get('field') === x.value) ? (orderBy.get('asc') ? 'asc' : 'desc') : '' }>
                                                            { x.caption }
                                                        </th>
                                                    )
                                                })
                                            }
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            reportes.getIn(['compliance_purchasing_manager', 'data']).size > 0 ? reportes.getIn(['compliance_purchasing_manager', 'data']).map((x, index) => {
                                                return (
                                                    <tr key={`tr1[${x.get('responsable')}${index}]`} className={x.get('selected') ? 'info' : ''}>
                                                        {
                                                            tableCols.map(c => {
                                                                let alignment = 'left';
                                                                let value = findValues(c, x)
                                                                if (c.type) {
                                                                    switch (c.type) {
                                                                        case 'datetime':
                                                                            value = value ? moment(value).format(c.format) : '';
                                                                            alignment = 'right';
                                                                            break
                                                                        case 'bool':
                                                                            if (typeof value === 'string') value = parseInt(value, 10)
                                                                            value = <div style={{ textAlign: 'center', fontSize: '1.1em' }}><i className={`fa fa-${value ? 'check-' : ''}square`} /></div>
                                                                            break
                                                                        case 'number':
                                                                            value = numeral(value).format(c.format)
                                                                            alignment = 'right'
                                                                            break
                                                                        default:
                                                                    }
                                                                }
                                                                const style = { textAlign: alignment }

                                                                    return (
                                                                        <td key={`td1[${x.get('responsable')}][${c.id}]`} style={style}>{value}</td>
                                                                    )
                                                            })
                                                        }
                                                    </tr>
                                                )
                                            }) : <tr><td colSpan={tableCols.length}>No existen registros</td></tr>
                                        }
                                    </tbody>
                                </table>
                            
                            </div>
                        </div>
                        
                    </Box>
                </div>
                <ModalSelectorFromList />
                <ModalFilter />
            </div>
        );
    }
}



const mapStateToProps = (state) => {
    const { reportes } = state;
    return {
        reportes,
        orderBy: reportes.getIn(['compliance_purchasing_manager', 'orderBy']),
        enums: state.common.get('enums').toJS(),
        showRecords: reportes.getIn(['compliance_purchasing_manager', 'showRecords']),
        totalRecords: reportes.getIn(['compliance_purchasing_manager', 'totalRecords']),
        page: reportes.getIn(['compliance_purchasing_manager', 'page']),
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        showModalSelector: (title, fields, url, action) => dispatch(showModalSelector(title, fields, url, action)),
        showHideModalFilter: (state, tableCols) => dispatch(showHideModalFilter(state, tableCols, 'compliance_purchasing_manager')),
        setOrderBy: (field) => dispatch(setOrderBy(field, 'compliance_purchasing_manager')),
        selectFromSelector: (type, payload) => dispatch(selectFromSelector(type, payload)),
        changeNumberRecordsToShow: (number) => dispatch(changeNumberRegisterToShow(number, 'compliance_purchasing_manager')),
        search: (page = 1) => dispatch(getCumplimientoResponsableCompras(page)),
        downloadFile: (url, params, type) => dispatch(downloadFile(url, params, `Cumplimiento responsable compras.${type}`)),
        updateInputs: (path, value) => dispatch(updateInputs(path, value)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(CumplimientoResponsableCompras);


// WEBPACK FOOTER //
// ./src/components/Reportes/CumplimientoResponsableCompras.jsx